import React from 'react'
import logo from '../../../assets/images/logoNeuReader1.png'
import './TheSidebar.css'
import DropdownItem from './DropdownItem'
import { Data_sidebar } from '../../../data/data_sidebar'
import SignOut from './SignOut'

function TheSidebar() {
  return (
    <aside className="fixed bottom-0 left-0 right-0 top-0 w-[25vw] border border-gray-200 bg-zinc-100 transition">
      <div className="flex h-[100vh] w-full flex-col justify-between">
        <div className="">
          <figure className="my-4 h-[10vh]">
            <img
              src={logo}
              alt=""
              className="m-auto mt-2 h-full object-cover"
            />
          </figure>
          <nav className="toggle-scroll scroll-stable-center h-[75vh]">
            {Data_sidebar.map((item, index) => {
              return <DropdownItem key={index} dataSidebar={item} />
            })}
          </nav>
        </div>
        <SignOut />
      </div>
    </aside>
  )
}

export default TheSidebar
